import React, { useState } from "react";
//* Menu slice iteams
import { useLocation, useNavigate } from "react-router-dom";
import { useMenuIteams } from "../../hooks/useMenuIteams";
import { imagesgeneral } from "../../assets/type_assets";
import { Menu } from "./Menu";
import { useReduxUI } from "../../hooks/redux/useReduxUI";

export const MenuSlice = () => {
	const local = useLocation().pathname;
	const [activeItem, setActiveItem] = useState("");
	const { iteamsMenu } = useMenuIteams(local);
    const { isMobileView, toggledSesionModal } = useReduxUI();
    const navigate = useNavigate();
	const selectMenu = (value) => {
		if (isNaN(parseInt(value.key))) {
            if (value.key === "/") {
                // cerrar sesion
                toggledSesionModal(true)
			} else if (value.key !== "n/a") {
				navigate(value.key);
				setActiveItem(value.label);
			}
		}
	};

	return (
        <div>
			<figure className={`w-full h-16 ${process.env.NODE_ENV === "production" ? "" : "bg-[#49829E]"}`}>
				<img className="w-full h-full object-contain" src={imagesgeneral.logo_blanco} alt="logo" />
			</figure>
			<Menu
				selectIteam={activeItem}
				items={iteamsMenu}
				onClick={(item) => {
					selectMenu(item);
					isMobileView();
				}}
			/>
        </div>
	);
};
